import React from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  Stack,
  Chip,
  Button,
  Card,
  CardContent,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import RssFeedOutlinedIcon from "@mui/icons-material/RssFeedOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MarketingSiteHeader from "./MarketingSiteHeader";
import MarketingSiteFooter from "./MarketingSiteFooter";

/**
 * Placeholder magazine layout for the public blog (production: https://www.quillai.app/blog).
 *
 * @returns {React.ReactElement}
 */
const BlogComingSoonPage = () => {
  const stubPosts = [
    { title: "Product notes", tag: "Roadmap" },
    { title: "Behind the template library", tag: "Product" },
    { title: "B2B docs that actually ship", tag: "Practice" },
    { title: "Sessions → deliverables", tag: "Workflow" },
    { title: "Security & AI at work", tag: "Trust" },
    { title: "Customer stories (soon)", tag: "Stories" },
  ];

  return (
    <Box sx={{ bgcolor: "background.default", color: "text.primary", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <MarketingSiteHeader />

      <Box component="main" sx={{ flex: 1 }}>
        <Box
          sx={{
            py: { xs: 5, md: 8 },
            background: "linear-gradient(160deg, rgba(249,72,74,0.07) 0%, rgba(74,0,224,0.07) 50%, rgba(16,185,129,0.05) 100%)",
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Container maxWidth="lg">
            <Button
              component={RouterLink}
              to="/"
              startIcon={<ArrowBackIcon />}
              color="inherit"
              sx={{ textTransform: "none", mb: 3, fontWeight: 600 }}
            >
              Home
            </Button>
            <Stack direction="row" alignItems="center" spacing={1.5} sx={{ flexWrap: "wrap", gap: 1, mb: 2 }}>
              <RssFeedOutlinedIcon color="secondary" sx={{ fontSize: 28 }} />
              <Typography variant="overline" color="secondary" fontWeight={700} sx={{ letterSpacing: 1 }}>
                Blog
              </Typography>
              <Chip label="Coming soon" color="warning" size="small" sx={{ fontWeight: 700 }} />
            </Stack>
            <Typography variant="h3" component="h1" fontWeight={800} sx={{ mb: 2, maxWidth: 720 }}>
              Ideas for teams who live in proposals, SOWs, and delivery docs
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 680, lineHeight: 1.75 }}>
              Long-form posts, release highlights, and workflow guides will live here. Rough layout below—nothing is published yet.
            </Typography>
            <Paper
              elevation={0}
              sx={{
                mt: 3,
                p: 2,
                borderRadius: 2,
                border: "1px dashed",
                borderColor: "divider",
                bgcolor: "rgba(255,255,255,0.65)",
              }}
            >
              <Typography variant="body2" color="text.secondary">
                Production URL:{" "}
                <Box component="span" fontWeight={700} color="text.primary">
                  https://www.quillai.app/blog
                </Box>
              </Typography>
            </Paper>
          </Container>
        </Box>

        <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 3, md: 4 },
              mb: 4,
              borderRadius: 3,
              border: "1px solid",
              borderColor: "divider",
              background: "linear-gradient(135deg, rgba(74,0,224,0.06), rgba(255,255,255,0.95))",
            }}
          >
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ flexWrap: "wrap", gap: 2, mb: 1 }}>
              <Chip label="Featured · Coming soon" color="primary" size="small" sx={{ fontWeight: 700 }} />
            </Stack>
            <Typography variant="h5" fontWeight={800} sx={{ mb: 1 }}>
              Why we built a workspace around meetings—not a generic chat box
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 720, lineHeight: 1.65 }}>
              This hero post will anchor the blog: how transcripts, templates, and approvals fit together for B2B teams.
              Placeholder copy only.
            </Typography>
            <Box sx={{ mt: 3, display: "flex", gap: 1, flexWrap: "wrap" }}>
              <Box sx={{ height: 8, width: "44%", borderRadius: 1, bgcolor: "action.hover" }} />
              <Box sx={{ height: 8, width: "28%", borderRadius: 1, bgcolor: "action.hover" }} />
              <Box sx={{ height: 8, width: "60%", borderRadius: 1, bgcolor: "action.hover" }} />
            </Box>
          </Paper>

          <Typography variant="h6" fontWeight={700} sx={{ mb: 2 }}>
            Latest (stub grid)
          </Typography>
          <Grid container spacing={2}>
            {stubPosts.map((post) => (
              <Grid item xs={12} sm={6} md={4} key={post.title}>
                <Card elevation={0} sx={{ height: "100%", border: "1px solid", borderColor: "divider", borderRadius: 2 }}>
                  <CardContent>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
                      <Chip label={post.tag} size="small" variant="outlined" sx={{ fontWeight: 600 }} />
                      <Chip label="Soon" size="small" color="warning" sx={{ fontWeight: 700 }} />
                    </Stack>
                    <Typography variant="subtitle1" fontWeight={800}>
                      {post.title}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
                      Rough card — replace with real excerpt and date.
                    </Typography>
                    <Box sx={{ mt: 2, height: 64, borderRadius: 1, bgcolor: "action.hover" }} />
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      <MarketingSiteFooter />
    </Box>
  );
};

export default BlogComingSoonPage;
